export default function selector(state, ownProps) {
  return {
    isGameStarted: state.app.isStarted,
  }
}


// WEBPACK FOOTER //
// ./src/models/app/selectors.js